import { render, staticRenderFns } from "./personPosition.vue?vue&type=template&id=53aa93ac"
import script from "./personPosition.vue?vue&type=script&lang=js"
export * from "./personPosition.vue?vue&type=script&lang=js"
import style0 from "./personPosition.vue?vue&type=style&index=0&id=53aa93ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports